<template>
  <div class="page-wrap">
    <v-form ref="form" @submit.prevent="onSubmit">
      <v-card class="tool-card" elevation="2">
        <div class="tool-card__accent"></div>

        <v-card-item class="pt-5">
          <template v-slot:prepend>
            <v-avatar color="secondary" rounded="lg" size="44">
              <v-icon :icon="icon" color="#231F20" size="24"></v-icon>
            </v-avatar>
          </template>
          <v-card-title class="text-h6">{{ title }}</v-card-title>
          <v-card-subtitle class="tool-card__subtitle">{{ description }}</v-card-subtitle>
        </v-card-item>

        <v-divider class="mt-4"></v-divider>

        <v-card-text class="pt-6 pb-2">
          <v-row>
            <slot></slot>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            :loading="loading"
            :disabled="loading"
            color="primary"
            variant="flat"
            size="large"
          >{{ submitLabel }}</v-btn>
        </v-card-actions>
      </v-card>

      <v-alert
        v-if="message != null"
        :type="succeeded ? 'success' : 'error'"
        variant="tonal"
        :icon="succeeded ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline'"
        class="text-start mt-6"
      >{{ succeeded && successMessage ? successMessage : message }}</v-alert>
    </v-form>
  </div>
</template>

<script>
// Shared chrome for the single-action tool pages.
//
// ChangeAuth0Email, ChangeAuth0AssociatedMembership and CheckForErrors were
// three copies of the same template and the same submit handler. They now
// supply only their own fields and their own API call.
//
// Validation lives here on purpose: the form owns its ref, so `submit` is
// emitted only for a valid form and no page can forget to check.
export default {
  name: "ActionForm",
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    submitLabel: { type: String, required: true },
    icon: { type: String, default: "mdi-tools" },
    loading: { type: Boolean, default: false },
    // HTTP status of the last response, or null before the first submit.
    status: { type: Number, default: null },
    // Body/message to display. `null` hides the alert entirely.
    message: { type: [String, Object, Number], default: null },
    // Optional text to show instead of `message` on success.
    successMessage: { type: String, default: null },
  },
  emits: ["submit"],
  computed: {
    succeeded() {
      return this.status === 200;
    },
  },
  methods: {
    async onSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (valid) this.$emit("submit");
    },
  },
};
</script>
